module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container body"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    attrs: {
      "id": "sidebar"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "header"
    }
  }), _vm._v(" "), _c('NavigaionBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stateName != 'login' && _vm.stateName != 'resetpassword' && _vm.stateName != 'signup' && _vm.stateName != 'signupconfirm'),
      expression: "stateName!='login' && stateName!='resetpassword' && stateName!='signup' && stateName!='signupconfirm'"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid bg-body",
    style: (_vm.stateName == 'login' || _vm.stateName == 'resetpassword' || _vm.stateName == 'signup' || _vm.stateName == 'signupconfirm' ? 'min-height:inherit !important' : ''),
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "notification_sidebar"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 816
// module chunks = 1